// extracted by mini-css-extract-plugin
module.exports = {"markAsFailedButton":"HistoryDetailsModal-markAsFailedButton-1FJNm Button-button-2PYOE Link-link-1rgM9"};